import { ProductName, RecurringInterval } from 'shared/interfaces/Product';
import { Subscription } from 'shared/interfaces/Subscription';

export const EMPTY_SUBSCRIPTION: Subscription = {
  organisation: '',
  user: '',
  product: {
    stripeId: '',
    stripePriceId: '',
    name: ProductName.STARTER,
    price: 0,
    recurringInterval: RecurringInterval.MONTH,
    embeddingTokenLimit: 0,
    usageTokenLimit: 0,
    totalFileStorageLimit: 0, // in Bytes
    totalVideosTimeLimit: 0, // in seconds
    totalVoiceCallSecondsLimit: 0,
    totalProvidedPhoneNumbersLimit: 0,
    totalPhoneNumbersLimit: 0,
    smartAssistantIntegrations: false,
    enableGoogleDrive: false,
    enabledTools: [],
    enableApiAccess: false,
    enableWhiteLabel: false,
    enableSpecialModels: false,
    enableConversationAnalytics: false,
    enableTakeover: false,
    enableZapierAccess: false,
    storeProductsCount: 0,
    enableWhatsApp: false,
    enableFacebook: false,
    enableInstagram: false,
    enableSync: false,
    enableByok: false,
    enableDashboardShareLink: false,
    enableImageChatAttachment: false,
    enableAudioChatAttachment: false,
    resourcePerSmartAssistantLimit: 0,
    isCustom: false,
    adminLimit: 0,
    memberLimit: 0,
    removePoweredBy: false
  },
  startDate: 0,
  renewDate: 0,
  subscriptionDuration: 0,
  stripeCustomerId: '',
  stripeSubscriptionId: '',
  promoCode: {
    stripeId: '',
    stripeCouponId: '',
    numberOfMonths: 0,
    discountPercentage: 0
  }
};
